import {damsFetch} from "../app/damsFetch";
import decamelizeKeysDeep from "decamelize-keys-deep";
import {patchPlaceNames} from "../place/patchPlaceNames";

export const savePublishingTagsWithModel = async (model, tags) => {
    if (!tags || !Array.isArray(tags)) {
        throw new Error("Tags must be an array");
    }

    const {publish} = model.content || {};
    const modelTags = publish?.tags || [];
    const uniqueTags = tags.filter(tag => !modelTags.some(existingTag => existingTag.reference.title === tag.reference.title));

    model.content.publish = {'tags': [...(modelTags || []), ...uniqueTags]};

    patchPlaceNames([model], true);

    return await damsFetch(`/documents`, {
        method: "POST",
        body: JSON.stringify(decamelizeKeysDeep(model)),
    });
};